"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexToId = indexToId;

var _operators = require("rxjs/operators");

var _AccountIndex = require("@plugnet/types/type/AccountIndex");

var _types = require("@plugnet/types");

var _drr = require("../util/drr");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function indexToId(api) {
  return _accountIndex => {
    const querySection = api.query.indices || api.query.balances;
    const accountIndex = _accountIndex instanceof _types.AccountIndex ? _accountIndex : new _types.AccountIndex(_accountIndex);
    return querySection.enumSet(accountIndex.div(_AccountIndex.ENUMSET_SIZE)).pipe((0, _operators.startWith)([]), (0, _operators.map)(accounts => (accounts || [])[accountIndex.mod(_AccountIndex.ENUMSET_SIZE).toNumber()]), (0, _drr.drr)());
  };
}